import { render, staticRenderFns } from "./MainCategories.vue?vue&type=template&id=02167de7&lang=pug"
import script from "./MainCategories.vue?vue&type=script&lang=js"
export * from "./MainCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports